import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

function ObsPopup({ open, onClose }) {
  useEffect(() => {
    if (!open) {
      return undefined;
    }

    const handleKeydown = (event) => {
      if (event.key === 'Escape') {
        onClose();
      }
    };

    window.addEventListener('keydown', handleKeydown);
    return () => window.removeEventListener('keydown', handleKeydown);
  }, [open, onClose]);

  if (!open) {
    return null;
  }

  return (
    <div
      className="obs-popup__backdrop"
      role="presentation"
      onClick={onClose}
    >
      <div
        className="obs-popup__card"
        role="dialog"
        aria-modal="true"
        aria-labelledby="obs-popup-message"
        onClick={(event) => event.stopPropagation()}
      >
        <p id="obs-popup-message" className="obs-popup__message">
          Our OBS extension is in development. For now, please use the web version.
        </p>
        <button
          type="button"
          className="obs-popup__close"
          onClick={onClose}
        >
          Close
        </button>
      </div>
    </div>
  );
}

ObsPopup.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default ObsPopup;
